import Crud from '../views/TypeProfessionals/Crud'
import Entity from '../views/TypeProfessionals/Add'

let routes = {
    path: '/typeprofessionals',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/typeprofessionals/add',
            name: 'NewTypeProfessional',
            component: Entity,
            meta: {
                ability: 'tipos_profissional.gerenciar',
                pageTitle: 'Type Of Professional',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/typeprofessionals'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/typeprofessionals/edit/:id?',
            name: 'EditTypeProfessional',
            component: Entity,
            meta: {
                ability: 'tipos_profissional.gerenciar',
                pageTitle: 'Type Of Professional',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/typeprofessionals'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/typeprofessionals',
            name: 'list-typeprofessionals',
            component: Crud,
            meta: {
                ability: 'tipos_profissional.ver',
                pageTitle: 'Type Of Professional',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
